import styled from '@emotion/styled/macro';
import { BaseButton, Card, Variables } from '@enter/core';

export const PageDescription = styled.p`
    margin: 8px 0 24px;
    font-size: 14px;
    line-height: 1.4;
    color: ${Variables.ThemeLight.TextMild};
`;

export const AccountsCard = styled(Card)`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0;
    background-color: ${Variables.ThemeLight.Background3};
    border: 1px solid ${Variables.ThemeLight.Border1};
    box-shadow: none;
`;

export const CardHeader = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    padding: 20px 24px 16px;
`;

export const CardHeaderText = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
`;

export const CardTitle = styled.h2`
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.3;
    color: ${Variables.ThemeLight.TextStrong};
`;

export const CardSubtext = styled.p`
    margin: 0;
    font-size: 13px;
    line-height: 1.4;
    color: ${Variables.ThemeLight.TextMild};
`;

export const ConnectButton = styled(BaseButton)`
    flex-shrink: 0;
    padding: 0 12px 0 8px;
    white-space: nowrap;
`;

export const ConnectIcon = styled.span`
    display: inline-flex;
    margin-right: 6px;
`;

export const AccountList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
`;

export const AccountRow = styled.li`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 24px;
    border-top: 1px solid ${Variables.ThemeLight.Border1};
`;

export const Avatar = styled.div`
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 600;
    color: ${Variables.ThemeLight.TextMedium};
    background-color: ${Variables.ThemeLight.Background1};
`;

export const AccountBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
    flex: 1;
`;

export const AccountPrimary = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
`;

export const InstitutionName = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: ${Variables.ThemeLight.TextStrong};
`;

export const Masks = styled.span`
    font-size: 14px;
    color: ${Variables.ThemeLight.TextMedium};
`;

export const TypeChip = styled.span`
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: ${Variables.Rounded.large};
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: ${Variables.ThemeLight.TextMedium};
    background-color: ${Variables.ThemeLight.Background1};
    border: 1px solid ${Variables.ThemeLight.Border1};
`;

export const AccountMeta = styled.div`
    font-size: 13px;
    line-height: 1.4;
    color: ${Variables.ThemeLight.TextMild};
`;

export const EmptyState = styled.div`
    padding: 24px;
    border-top: 1px solid ${Variables.ThemeLight.Border1};
    font-size: 14px;
    color: ${Variables.ThemeLight.TextMild};
`;

export const LoadingState = styled.div`
    padding: 32px 24px;
    display: flex;
    justify-content: center;
    border-top: 1px solid ${Variables.ThemeLight.Border1};
`;
